import React, { createContext, useCallback, useContext, useState } from 'react';

export interface DashboardHeaderSlot {
  component?: 'studio' | 'user' | 'users' | 'project' | 'projects';
  breadcrumb?: React.ReactNode;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

interface ContextValue {
  slot: DashboardHeaderSlot;
  setSlot: (slot: DashboardHeaderSlot) => void;
}

const DashboardHeaderContext = createContext<ContextValue>({
  slot: {},
  setSlot: () => {},
});

export function DashboardHeaderProvider({ children }: { children: React.ReactNode }) {
  const [slot, setSlotState] = useState<DashboardHeaderSlot>({});
  const setSlot = useCallback((next: DashboardHeaderSlot) => setSlotState(next), []);
  return <DashboardHeaderContext.Provider value={{ slot, setSlot }}>{children}</DashboardHeaderContext.Provider>;
}

export function useDashboardHeaderSlot(): DashboardHeaderSlot {
  return useContext(DashboardHeaderContext).slot;
}

export function useSetDashboardHeader(): (slot: DashboardHeaderSlot) => void {
  return useContext(DashboardHeaderContext).setSlot;
}
